<template>
  <div class="footer" :class="footerClass">
    <div class="terms">
      <div @click="goPrivacy">{{ $t('common.footer.privacyPolicy') }}</div>
      <div @click="goTerms">{{ $t('common.footer.termsOfUse') }}</div>
    </div>
    <div class="copyright">COPYRIGHT © {{ year }} KKday All rights reserved.</div>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  data() {
    return {
      year: dayjs().year(),
      footerClass: ''
    }
  },
  created(){
    setTimeout(()=> {
      this.footerClass = 'visible'
    }, 200)
  },
  methods: {
    goPrivacy() {
      const lang = localStorage.getItem('lang') || 'en'
      window.open('https://www.kkday.com/static/' + lang +'/about/privacy.html')
    },
    goTerms() {
      const lang = localStorage.getItem('lang') || 'en'
      if (lang === 'ja') {
        this.$router.push('/ja-terms')
      } else {
        this.$router.push('/terms')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.footer {
  width: 100%;
  height: 67px;
  position: relative;
  flex-wrap: wrap;
  left: 0%;
  bottom: 0%;
  z-index: 1000;
  background: #212121;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #BABBBE;
  font-size: 14px;
  padding: 0 var(--kk-spacing-7);
  box-sizing: border-box;
  margin-top: auto;
  visibility: hidden;
  .terms {
    display: flex;
    align-items: center;
    gap: var(--kk-spacing-8);
    >* {
      cursor: pointer;
    }
  }
  .copyright {}
}
.visible{
  visibility: visible;
}
</style>
